// import './css'
import Vue from 'vue'
import Inbound from './Inbound'

Vue.use(Inbound)
